import { AffectedOptimizationGroupsModal } from '@/pages/_modals/affected-optimization-groups'
import { AddSkuToAnchorAssortmentModal } from '@/pages/_modals/anchor/assortment/add-sku'
import { AssignToAnchorManagementModal } from '@/pages/_modals/anchor/assortment/assign-to'
import { ExportAnchorAssortmentTableModal } from '@/pages/_modals/anchor/assortment/export-assortment-table'
import { ImportAnchorAssortmentFromFileModal } from '@/pages/_modals/anchor/assortment/import-assortment'
import { CreateAnchorStrategyModal } from '@/pages/_modals/anchor/strategy/create'
import { StrategyModal } from '@/pages/_modals/anchor/strategy/edit'
import { GlobalSetsCompareModal } from '@/pages/_modals/compare-global-sets'
import { ScenariosCompareModal } from '@/pages/_modals/compare-scenarios'
import { CopyScenarioSettingsModal } from '@/pages/_modals/copy-scenario-settings'
import {
	CreateAdditionalDataExportModal,
	CreateAssortmentDataExportModal,
} from '@/pages/_modals/create-data-export'
import { CreateGlobalPcSetModal } from '@/pages/_modals/create-global-pc-set'
import { CreateOptimizationGroupModal } from '@/pages/_modals/create-optimization-group'
import { CreateReportModal } from '@/pages/_modals/create-report'
import { CreateScenarioModal } from '@/pages/_modals/create-scenario'
import { CreateTicketModal } from '@/pages/_modals/create-ticket'
import { DataExportsModal } from '@/pages/_modals/data-exports'
import {
	OptimizationGroupModal,
	UpdateGeneralInfoModal,
} from '@/pages/_modals/edit-optimization-group'
import { EditReportModal } from '@/pages/_modals/edit-report'
import { ScenarioModal } from '@/pages/_modals/edit-scenario'
import { GenericRenameModal } from '@/pages/_modals/generic-rename'
import { ImportOptimizationGroupsModal } from '@/pages/_modals/import-optimization-groups'
import { OptimizationReviewModal } from '@/pages/_modals/optimization-review'
import { OptimizationScheduleModal } from '@/pages/_modals/optimization-schedule'
import { OptimizationSchedulesModal } from '@/pages/_modals/optimization-schedules'
import { CopyPricingCampaignModal } from '@/pages/_modals/pricing-campaign/copy'
import { CopyPricingCampaignSettingsModal } from '@/pages/_modals/pricing-campaign/copy-settings'
import { CreatePricingCampaignModal } from '@/pages/_modals/pricing-campaign/create'
import { DuplicatePricingCampaignToGlobalPcSetsModal } from '@/pages/_modals/pricing-campaign/duplicate/to-global-pc-set'
import { DuplicatePricingCampaignsModal } from '@/pages/_modals/pricing-campaign/duplicate/to-optimization-group'
import { PricingCampaignModal } from '@/pages/_modals/pricing-campaign/edit'
import { MovePricingCampaignsModal } from '@/pages/_modals/pricing-campaign/move'
import { PricingCampaignsPriorityModal } from '@/pages/_modals/pricing-campaign/priority'
import { ApplyPricingRuleModal } from '@/pages/_modals/pricing-rule/apply'
import { ApplySettingsTemplateModal } from '@/pages/_modals/settings-templates/apply'
import { SettingsTemplateModal } from '@/pages/_modals/settings-templates/edit'
import { SettingTemplatesModal } from '@/pages/_modals/settings-templates/select'
import {
	AssortmentImportModal,
	AssortmentUpdateModal,
	ProductsImportModal,
	ProductsUpdateModal,
} from '@/pages/_modals/update-products'

import {
	ChooseTypeModal,
	PricingCampaignConfirmationUpdateModal,
} from '@/entities/pricing-campaign'

const registry = {
	// Common modals
	CREATE_TICKET: CreateTicketModal,

	OPTIMIZATION_GROUPS_BULK_IMPORT: ImportOptimizationGroupsModal,
	OPTIMIZATION_GROUP_MODAL: OptimizationGroupModal,
	COPY_SETTINGS: CopyScenarioSettingsModal,
	OPTIMIZATION_SCHEDULE_MODAL: OptimizationScheduleModal,
	OPTIMIZATION_SCHEDULE_LIST_MODAL: OptimizationSchedulesModal,
	REVIEW_MANAGEMENT: OptimizationReviewModal,
	EXPORT_ADDITIONAL_DATA: CreateAdditionalDataExportModal,
	EXPORTS: DataExportsModal,
	EXPORT_ASSORTMENT: CreateAssortmentDataExportModal,
	GENERIC_RENAME_MODAL: GenericRenameModal,

	// pricing settings
	CREATE_OPTIMIZATION_GROUP: CreateOptimizationGroupModal,

	// Products modals
	UPDATE_PRODUCTS: ProductsUpdateModal,
	IMPORT_PRODUCTS: ProductsImportModal,

	// Assortment modals
	IMPORT_ASSORTMENT: AssortmentImportModal,
	UPDATE_ASSORTMENT: AssortmentUpdateModal,

	// Reports modals
	CREATE_ASSORTMENT_REPORT: CreateReportModal,
	UPDTAE_ASSORTMENT_REPORT: EditReportModal,

	// Anchor management modals
	IMPORT_ANCHOR_ASSORTMENT_FROM_FILE: ImportAnchorAssortmentFromFileModal,
	EXPORT_ANCHORS_TABLE: ExportAnchorAssortmentTableModal,
	CREATE_ANCHOR_STRATEGY_MODAL: CreateAnchorStrategyModal,
	ANCHOR_STRATEGY_MODAL: StrategyModal,
	ASSIGN_TO_ANCHOR_MANAGEMENT_MODAL: AssignToAnchorManagementModal,
	CREATE_ANCHOR_SKU_MODAL: AddSkuToAnchorAssortmentModal,

	// Scenarios modals
	CREATE_SCENARIO: CreateScenarioModal,
	EDIT_SCENARIO: ScenarioModal,
	SCENARIOS_COMPARE: ScenariosCompareModal,
	GLOBAL_SETS_COMPARE: GlobalSetsCompareModal,

	// Global pricing campaign sets modals
	CREATE_GLOBAL_PC_SET: CreateGlobalPcSetModal,

	// Pricing campaigns modals
	PRICING_CAMPAIGNS_PRIORITY: PricingCampaignsPriorityModal,
	PRICING_CAMPAIGN_MODAL: PricingCampaignModal,
	CREATE_PRICING_CAMPAIGN_MODAL: CreatePricingCampaignModal,
	COPY_PRICING_CAMPAIGN_SETTINGS: CopyPricingCampaignSettingsModal,
	UPDATE_OPTIMIZATION_GROUP_INFO: UpdateGeneralInfoModal,
	SELECT_COPY_PRICING_CAMPAIGN_FLOW: ChooseTypeModal,
	COPY_PRICING_CAMPAIGN: CopyPricingCampaignModal,
	DUBLICATE_PRICING_CANPAIGNS_TO_OPTIMIZATION_GROUP:
		DuplicatePricingCampaignsModal,
	DUBLICATE_PRICING_CANPAIGNS_TO_GLOBAL_PC_SET:
		DuplicatePricingCampaignToGlobalPcSetsModal,
	MOVE_PRICING_CANPAIGNS: MovePricingCampaignsModal,
	CONFIRM_PRICING_CAMPAIGN_SAVE: PricingCampaignConfirmationUpdateModal,

	APPLY_PRICING_RULE: ApplyPricingRuleModal,
	AFFECTED_OPTIMIZATION_GROUPS_MODAL: AffectedOptimizationGroupsModal,
	SETTINGS_TEMPLATE_MODAL: SettingsTemplateModal,
	SETTINGS_TEMPLATE_APPLY_MODAL: ApplySettingsTemplateModal,
	SETTING_TEMPLATES_MODAL: SettingTemplatesModal,
}
export default registry
